import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Courses from './pages/Courses';
import About from './pages/About';
import Contact from './pages/Contact';
import PythonProgrammingForBeginners from './pages/PythonProgrammingForBeginners';
import DataScienceFoundations from './pages/DataScienceFoundations';
import WebDevelopmentBasics from './pages/WebDevelopmentBasics';
import './index.css';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/python-programming-for-beginners" element={<PythonProgrammingForBeginners />} />
            <Route path="/courses/data-science-foundations" element={<DataScienceFoundations />} />
            <Route path="/courses/web-development-basics" element={<WebDevelopmentBasics />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
